import type { Step } from "react-joyride";

export const monthlyReportDetailTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ໜ້າລາຍລະອຽດລາຍງານປະຈໍາເດືອນ. ສະແດງຂໍ້ມູນເດືອນ ປີ ພະແນກ ແລະ ດາວໂຫຼດເອກະສານ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="monthly-report-detail-back"]',
    content:
      "ກັບຄືນໄປຫນ້າລາຍການລາຍງານປະຈໍາເດືອນ. ກົດປຸ່ມ ? ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="monthly-report-detail-content"]',
    content:
      "ຂໍ້ມູນລາຍລະອຽດ: ເດືອນ ປີ, ພະແນກ, ຊື່, ເອກະສານ (ດາວໂຫຼດ/ເປີດລິ້ງ), ຜູ້ສ້າງ.",
    placement: "top",
  },
];
